import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { FormControlLabel, FormGroup, Grid, Paper, Switch, TextField } from '@mui/material';

import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import SaveButton from '../ui/SaveButton';
import ServerError from '../ui/ServerError';
import VendorCommProgramAppFetch from './VendorCommProgramAppFetch';

import VendorCommProgramCreateMutation from './VendorCommProgramCreateMutation';
import ProgramType from './ProgramType';


const abEnvironment = new AbEnvironment();
const VendorCommProgramCreateQuery = graphql`
query VendorCommProgramCreateQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    accountType
    accountName
    cpTsByAccountId {
      nodes {
        programName
      }
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    }
});

class VendorCommProgramCreate extends Component {
    constructor(props) {
        super(props);

         this.state = {
            showSpinner: false,
            saveStatus: null,
            savedClicked: false,
            saveMessage: null,
            saveSnackbarOpen: false,
            saveSnackbarDuration: null,
            accountId : abEnvironment.getUserAttribute("a_id"),
            programName: '',
            description: '',
            publicView: 1,
            type: 0,
            notes: '',
            noAppsDefined: true,
            allAppsUsed: true,

         }
    }

    componentDidMount() {
      if (abEnvironment.isSegmentActive()) {  window.analytics.track('Setting up a commissions program'); }
  
      //this gets a list of all the vendor apps.
      let accountId = abEnvironment.getUserAttribute('a_id');
      VendorCommProgramAppFetch.fetch(accountId).toPromise()
      .then(vcpaf => {
  
        let i = 0;
        let appSelections = [];
        let allAppsUsed = true;
        for (i = 0; i < vcpaf.allAppTs.nodes.length; i++) {
          let appT = vcpaf.allAppTs.nodes[i]
          if (appT.appStatus === 0 || appT.appStatus === 2) {
            let appName = '';
            if (appT.appSku == null || appT.appSku === '') {
              appName = appT.appName;
            } else {
              appName = appT.appName + " (" + appT.appSku + ")";
            }
            if (appT.cpAppTsByAppId.totalCount === 0) {
              allAppsUsed = false;
            }

            let appSelection = {'appId' : appT.appId, 'appName': appName, 'selected' : (vcpaf.allAppTs.nodes.length === 1) ? true : false}; //auto select if 1
            appSelections.push(appSelection);
          }
        }
  
        if (appSelections.length > 0 && !allAppsUsed) {
          this.setState({ noAppsDefined: false, allAppsUsed: false});
        } else if (allAppsUsed) {
          this.setState({ noAppsDefined: false, allAppsUsed: allAppsUsed, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'All apps in app catalog have already been assigned to a commission program', saveSnackbarDuration: null });
        } else {
          this.setState({ noAppsDefined: true, allAppsUsed: allAppsUsed, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Please define your apps in catalog before setting up commission program.', saveSnackbarDuration: null });
        }
   
      })
      .catch(err => {
        //nothing to do....
      })
  
    }
  

    isRequiredFieldInError = (state_member) => {
      if (state_member === '' && this.state.saveClicked) {
        return 'Field is required';
      } else {
        return '';
      }
  
    }

    isProgramNameInError = (existingNames, programName) => {
      // if saved has been clicked, see if one app is selected.
      /*if (!this.state.saveClicked) {
        return '';
      }*/
  
      if (this.isRequiredFieldInError(this.state.programName) !== '') {
        return this.isRequiredFieldInError(this.state.programName);
      }

      let duplicate = false;
      let i = 0;
      for (i = 0; i < existingNames.length; i++) {
        let program = existingNames[i]
        if (program.programName === programName) {
          duplicate = true;
          break;
        }
      }
      if (duplicate === true) {
        return 'Program name already exists';
      } else {
        return '';
      }
  
    }

    changeProgramType = ( newType ) => {
      this.setState({type: newType});
    }

    goTo(url) {
      this.props.history.replace(`${url}`);
    }
  
    goBack() {
      this.props.history.goBack();
    }
    
    showSpinner() {
        return this.state.showSpinner;
    }

    disableSave(programs) {

      if (this.state.noAppsDefined) {
        return true;
      }

      if (this.isRequiredFieldInError(this.state.programName) !== '')
        return true;

      if (this.isProgramNameInError(programs, this.state.programName)  !== '') {
        return true;
      }
    
      if (this.isRequiredFieldInError(this.state.description) !== '')
        return true;
  
      let somethingChanged = false;
      
      if ((this.state.programName !== '') && (this.state.description !== '')) {
        somethingChanged = true;
      }


      if (somethingChanged) {
        return false;
      }
  
      return true;
    }
  
    render() {
        const { isAuthenticated, isAuthenticatedVendor, isAuthenticatedAppBind, needAssent, logError } = this.props.auth;
        const classes = this.props.classes;

        if (!isAuthenticated() || needAssent()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedAppBind() || isAuthenticatedVendor()) {
          const params = new URLSearchParams(this.props.location.search);
          let acctId = null;
          let acctIdFromParms = params.get('accountId');
          if (acctIdFromParms !== null) {
            acctId = acctIdFromParms;
          } else {
            acctId = abEnvironment.getUserAttribute('a_id');
          }

          return (
            <QueryRenderer
              environment={abEnvironment.getEnvironment()}
              query={VendorCommProgramCreateQuery}
              variables={{accountId: acctId}}
              render={({error, props})=> {
                if (error) {
                  logError(error.message);
                  return (
                    <ServerError/>
                  );
                } else if (props) {
                  let programs = props.accountTByAccountId.cpTsByAccountId.nodes;

             
                  return (
                    <Grid container spacing={3} direction="row" justifyContent="flex-start">
                      <Grid item xs={12}>
                        <PageTitle title="Add commission plan" showBackButton={true} name="Plans" noMargin={true} history={this.props.history}/>
                      </Grid>
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2}  style={{marginTop: 16}} direction="row" justifyContent="space-around">
                            <Grid item xs={12} sm={6}>
                              <TextField 
                                error={this.isProgramNameInError(programs, this.state.programName) !== ''}
                                id="program-name" label="Commission plan name *"
                                value={this.state.programName}
                                onChange={(e) => this.setState({ programName: e.target.value })}
                                inputProps={{ maxLength: 64 }}
                                helperText={this.isProgramNameInError(programs, this.state.programName)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormGroup style={{marginTop: 8}}>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={this.state.publicView === 1}
                                      onChange={(e, checked) => {
                                        if (this.state.publicView === 1) {
                                          this.setState({ publicView: 0});
                                        } else {
                                          this.setState({ publicView: 1});
                                        }
                                      }}
                                    />
                                  }
                                  label="Active"
                                />
                              </FormGroup>
                              
                            </Grid>
                            <Grid item  xs={12}>
                              <TextField 
                                error={this.isRequiredFieldInError(this.state.description) !== ''}
                                id="description" label="Description *"
                                value={this.state.description}
                                fullWidth
                                multiline
                                onChange={(e) => this.setState({ description: e.target.value })}
                                inputProps={{ maxLength: 2048 }}
                                helperText={this.isRequiredFieldInError(this.state.description)}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <TextField 
                                id="notes" label="Notes"
                                value={this.state.notes}
                                fullWidth
                                multiline
                                onChange={(e) => this.setState({ notes: e.target.value })}
                                inputProps={{ maxLength: 2048 }}
                              />
                            </Grid>
  
                            <Grid item xs={12}>
                              <ProgramType type={this.state.type} changeType={this.changeProgramType}/>
                            </Grid>

                            <Grid item xs={12}>
                              <SaveButton
                                snackbarOpen={this.state.saveSnackbarOpen}
                                autoHideDuration={this.state.saveSnackbarDuration}
                                label="Save"
                                status={this.state.saveStatus} 
                                message={this.state.saveMessage}
                                onSaveClick={() => { this.savedClicked(programs); }}
                                onSnackbarClose={() => { this.onSnackbarClose(); }}
                                disabled={this.disableSave(programs)}
                              />
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>
                    </Grid>
                  )
                }
                return <LoadingSpinner />
              }}
            />
          );
        } else {
          return (
            <Redirect to='/home' />
          );
        }
    }
   
    onSnackbarClose() {
      this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
    }

    savedClicked = (programs) => {
      //see this for more information: https://stackoverflow.com/questions/30782948/why-calling-react-setstate-method-doesnt-mutate-the-state-immediately
      this.setState({saveClicked: true}, function () {
        this.createProgram(programs);
      });
    }
  
    createProgram = (programs) => {

      if (this.disableSave(programs)) {
        return;
      }
 
      this.setState({ saveStatus: 'saving' });

      if (abEnvironment.isSegmentActive()) { window.analytics.track('Vendor creating new program'); }   
 
      this.setState({ showSpinner: true });
      const { accountId, programName, type, description, publicView, notes} = this.state;
      
      let theNewProgramId = null;

      VendorCommProgramCreateMutation.commit(accountId, type, programName, description, publicView, notes)
      .then(response => {
        theNewProgramId = response.createCpT.cpT.cpId;


        return null;
      })
      .then(response => {
        this.setState({ showSpinner: false });
        let replaceUrl = 'vendorcommprogramedit?cpId=' + theNewProgramId;
        if (abEnvironment.isSegmentActive()) { window.analytics.track('Vendor program created'); }   
        this.goTo(replaceUrl);
      })
      .catch(error => {
        this.setState({ showSpinner: false, snackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to save new program.' });
        // this.goBack();
      });
    }
}

VendorCommProgramCreate.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(VendorCommProgramCreate);